module.exports = __webpack_public_path__ + "static/media/board_data_check.a3b01cdf.png";